<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="16" style="background-color: #faf7f7;color: #606266">
        <div id="left" style="float:left; width:70%;line-height: 30px;">
          <br>
          BooleanDA文档小助手【简称 BDA小助手 】是一款为Word/PDF提供丰富、快捷批量处理的文档处理软件。卓越的性能造就了更多强
          劲功能：如WORD转PDF（双层）、PDF转双层PDF、图片转双层PDF、PDF批量插入/替换/删除新页、批量添加印章签名、
          核对页码、批量查找替换等。为投标、项目现场提供一键自动化批量处理，
          避免重复动作，助力“双碳”！
          <br><br>
        </div>
        <div id="right" style="float:right; width:30%;">
          <br><br>
          <p style="color: #006cff">累计处理<span style="font-size: 30px;font-weight: bold;margin: 8px 10px;">
            <vab-count
              :decimals="countConfig.decimals"
              :duration="countConfig.duration"
              :end-val="countConfig.endVal"
              :prefix="countConfig.prefix"
              :separator="countConfig.separator"
              :start-val="countConfig.startVal"
              :suffix="countConfig.suffix"
            />
          </span> 个</p>
          <p>（只统计总数）</p>
        </div>

      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="16" style="background-color: #f5f5f5">
        <el-carousel height="200px" direction="vertical" :autoplay="true" :interval="2500">
          <el-carousel-item v-for="item in items" :key="item.index">
            <div>{{ item.txt }}</div>
            <el-image :src=item.img></el-image>
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
import VabCount from '@/plugins/VabCount'

export default {
  name: 'Description',
  components: {
    VabCount
  },
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      items: [
        { txt: 'Word增强工具', img: 'http://www.booleanda.cc/vba/images/back/wordPanel.png' },
        { txt: 'Excel增强工具', img: 'http://www.booleanda.cc/vba/images/back/excelPanel.png' }
      ],
      countConfig: {
        startVal: 18600000,
        endVal: 18608669,
        decimals: 0,
        prefix: '',
        suffix: '',
        separator: ',',
        duration: 5000
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.el-row {
  margin-bottom: 10px;
  /*&:last-child {*/
  /*   margin-bottom: 0;*/
  /* }*/
}
.el-col {
  border-radius: 4px;
  text-align: center;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.txt {
  color: #f2f4f6;
  font-size: 14px;
  opacity: 0.75;
  line-height: 40px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  //background-color: #035e03;
  color: #0c810c;
  font-size: 30px;
  //opacity: 0.75;
  line-height: 60px;
  margin: 0;
}

.el-carousel__item:nth-child(2n+1) {
  //background-color: #1471f3;
  color: #1471f3;
  font-size: 30px;
  //opacity: 0.75;
  line-height: 60px;
  margin: 0;
}
::v-deep .el-carousel__indicators{
  color: #006cff;
}

</style>
